/**
 * 이미지 프리로딩 유틸리티
 * 실무에서 많이 사용하는 이미지 최적화 기법
 */

/**
 * 단일 이미지 프리로드
 */
export const preloadImage = (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = url;
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Failed to preload image: ${url}`));
    document.head.appendChild(link);
  });
};

/**
 * 여러 이미지 프리로드
 */
export const preloadImages = (urls: string[]): Promise<void[]> => {
  return Promise.all(urls.map(url => preloadImage(url).catch(() => {})));
};

/**
 * 자주 사용되는 공통 이미지 프리로드
 */
export const preloadCommonImages = (): void => {
  const commonImages = [
    '/coin.png',
    '/backcard.png',
    '/gacha.png',
    '/home.png',
    '/inventory.png',
    '/arena_asset_free.webp',
  ];

  // 비동기로 실행하되 에러는 무시 (이미 로드된 경우 등)
  preloadImages(commonImages).catch(() => {});
};

